import { render, staticRenderFns } from "./DashboardUsageInfo.vue?vue&type=template&id=6b23780f&scoped=true"
import script from "./DashboardUsageInfo.vue?vue&type=script&lang=js"
export * from "./DashboardUsageInfo.vue?vue&type=script&lang=js"
import style0 from "./DashboardUsageInfo.vue?vue&type=style&index=0&id=6b23780f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23780f",
  null
  
)

export default component.exports